/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".row[_ngcontent-%COMP%]{margin:0;position:absolute;top:50%;left:55%;transform:translate(-50%,-50%)}.full[_ngcontent-%COMP%]{min-height:40rem}"];
export { styles as styles };
